import React, { useEffect, useState } from 'react'
import { IoMdClose } from "react-icons/io";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CalendarIcon from "../../../../assets/images/Icons/calendarIcon.svg";
import { FaCalendar } from "react-icons/fa";
import DownArrow from "../../../../../src/assets/images/Icons/icons/down_arrow.svg";
import UpArrow from "../../../../../src/assets/images/Icons/icons/up_arrow.svg";
import { makeAjax, respStatus, url, showMessage } from '../../../../helpers/global_helper';
import { useDispatch, useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
// import { formatPrice } from "../../NumberFormat";
// import InvoiceTogleBetPopup from './InfoSubComponents/InvoiceTogleBetPopup';
const InfoResultLinkPopup = (props) => {
  const { onClose, response } = props;

  const [startDate, setStartDate] = useState(new Date());
  const [selectGameName, setSelectGameName] = useState("Combodia");
  const [gameName, setGameName] = useState([]);

  const pageNumber = useSelector((state) => state.paginationData.pageNumber)
  const perPage = useSelector((state) => state.paginationData.dataInOnePage)
  const [transectionData, setTransectionData] = useState([]);
  const [showBetPopup, setBetShowPopup] = useState(false);
  const [loading, setLoading] = useState(false)
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [totalData, setTotalData] = useState([]);
  const [win, setWin] = useState("");
  const [subgame, setSubgame] = useState("");

  const date = new Date(startDate);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Adding 1 to month because it's zero-indexed
  const day = date.getDate().toString().padStart(2, '0');
  const formattedDate = `${year}-${month}-${day}`;
  // api for Game list
  const featchGameList = () => {
    makeAjax(url.TOGEL_API.listGame).then((response) => {
      if (response.status != respStatus["SUCCESS"]) {
        if (response.code != "validation_error") {
          showMessage(response);
          return;
        }
        showMessage(response);
        return;
      }
      setGameName(response.data);
    });
  };
  useEffect(() => {
    featchGameList();
  }, []);
  useEffect(() => {
    featchTransectionList();
    const container = document.querySelector('.informasi_tble_result');
    if (container) {
      container.scrollTop = 0;
    }
  }, [perPage, pageNumber]);

  const featchTransectionList = () => {
    setLoading(true)
    let reqData = {
      // page: pageNumber,
      date: formattedDate,
      game_id: selectGameName == "Combodia" ? 202 : parseInt(selectGameName),
      // date: "2024-05-28",
      // game_id: 201,
      // length: perPage,
    };
    makeAjax(url.TOGEL_API.listInvoiceTogelData, reqData).then((response) => {
      if (response.status != respStatus["SUCCESS"]) {
        if (response.code != "validation_error") {
          showMessage(response);
          return;
        }
        showMessage(response);
        return;
      }
      setTotalData(response.data)

      setTransectionData(response.data.list_subgame);
      setLoading(false)
    });
  }
  const CustomInput = ({ value, onClick }) => (
    <div style={{ position: "relative" }} className="custom_calendar">
      <input
        type="text"
        value={value}
        onClick={onClick} // This opens the calendar on input click
        readOnly // Prevent direct text input
      />
      <button
        onClick={onClick} // This also opens the calendar on icon click

        style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: "pointer"
        }}
      >
        {/* <img src={CalendarIcon} alt="" /> */}
        <FaCalendar />
      </button>
    </div>
  );
  const handleSort = (column) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(column);
      setSortOrder("asc");
    }
  };

  const sortedData = () => {
    if (sortBy === "buy" || sortBy === "pay") {
      return transectionData.slice().sort((a, b) => {
        const aValue = parseFloat(a[sortBy]);
        const bValue = parseFloat(b[sortBy]);
        return sortOrder === "asc" ? aValue - bValue : bValue - aValue;
      });
    } else if (sortBy === "pay" || sortBy === "win") {
      return transectionData.slice().sort((a, b) => {
        const aValue = parseFloat(a[sortBy]);
        const bValue = parseFloat(b[sortBy]);
        return sortOrder === "asc" ? aValue - bValue : bValue - aValue;
      });
    } else if (sortBy) {
      return transectionData.slice().sort((a, b) => {
        const aValue = a[sortBy].toLowerCase();
        const bValue = b[sortBy].toLowerCase();
        return sortOrder === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      });
    }
    return transectionData;
  };

  const handleGameSelectOptions = (e) => {
    const selectedValue = e.target.value;
    setSelectGameName(selectedValue);
  };
  const handleSearchData = () => {
    const container = document.querySelector('.informasi_tble_result');
    if (container) {
      container.scrollTop = 0;
    }
    featchTransectionList();
  };
  const closeInvoiceTogelPopup = () => {
    setBetShowPopup(false);
  };
  const handleInvoiceToglePopup = (win, subgame) => {
    setWin(win);
    setSubgame(subgame)
    setBetShowPopup(true);
  };

  return (
    <div className="overlay">
      <div className='overlay_innerDiv' onClick={onClose}></div>
      <div className="informasi_popup">
        <button className="informasi_popup-close" onClick={onClose}>
        <IoMdClose className="btnclose"/>
        </button>
        <div className="result_txt" style={{ textTransform: "uppercase" }}>{response.game.game_name} - PERIODE {response.period}</div>
        <div className='trasaction_popup'>

          <div className="result_link_top_bar statement_top_bar">
            ABCD, A=As, B=Kop, C=Kepala, D=Ekor
          </div>
          {/* table */}
          <div className="informasi_tble_result statement_tble_result">
            <table >
              <thead>
                <tr >
                  <th>Games</th>
                  <th>A</th>
                  <th>B</th>
                  <th>C</th>
                  <th>D</th>
                </tr>
              </thead>
              <tbody>


                {/* {!loading && */}
                <tr className='even-row'>
                  <td>4D</td>
                  <td>{response.detail.as}</td>
                  <td>{response.detail.kop}</td>
                  <td>{response.detail.kepala}</td>
                  <td>{response.detail.ekor}</td>
                </tr>

                <tr className='odd-row'>
                  <td >3D</td>
                  <td>-</td>
                  <td>{response.detail.kop}</td>
                  <td>{response.detail.kepala}</td>
                  <td>{response.detail.ekor}</td>
                </tr>

                <tr className='even-row'
                >
                  <td>2D</td>
                  <td>-</td>
                  <td>-</td>
                  <td>{response.detail.kepala}</td>
                  <td>{response.detail.ekor}</td>
                </tr>

                <tr className='odd-row'
                >
                  <td>Colok Bebas</td>
                  <td>{response.detail.as}</td>
                  <td>{response.detail.kop}</td>
                  <td>{response.detail.kepala}</td>
                  <td>{response.detail.ekor}</td>
                </tr>

                <tr className='even-row'
                >
                  <td>Kombinasi</td>
                  <td>{props.t(response.detail.asGG)}</td>
                  <td>{props.t(response.detail.kopGG)}</td>
                  <td>{props.t(response.detail.kepalaGG)}</td>
                  <td>{props.t(response.detail.ekorGG)}</td>
                </tr>
                <tr className='odd-row'
                >
                  <td></td>
                  <td>{props.t(response.detail.asBS)}</td>
                  <td>{props.t(response.detail.kopBS)}</td>
                  <td>{props.t(response.detail.kepalaBS)}</td>
                  <td>{props.t(response.detail.ekorBS)}</td>
                </tr>

                <tr className='even-row'
                >
                  <td>Colok Jitu</td>
                  <td>{response.detail.as}</td>
                  <td>{response.detail.kop}</td>
                  <td>{response.detail.kepala}</td>
                  <td>{response.detail.ekor}</td>
                </tr>

                <tr className='odd-row'
                >
                  <td>50-50</td>
                  <td>{props.t(response.detail.asGG)}</td>
                  <td>{props.t(response.detail.kopGG)}</td>
                  <td>{props.t(response.detail.kepalaGG)}</td>
                  <td>{props.t(response.detail.ekorGG)}</td>
                </tr>

                <tr className='even-row'
                >
                  <td></td>
                  <td>{props.t(response.detail.asBS)}</td>
                  <td>{props.t(response.detail.kopBS)}</td>
                  <td>{props.t(response.detail.kepalaBS)}</td>
                  <td>{props.t(response.detail.ekorBS)}</td>
                </tr>

                <tr className='odd-row'>
                  <td>50-50 2D</td>
                  <td colspan="4">{props.t(response.detail.lima2dBS) + ' - ' + props.t(response.detail.lima2dGG)}</td>
                </tr>

                <tr className='even-row'>
                  <td>Colok Bebas 2D</td>
                  {Array.from({ length: 4 }).map((_, index) => (
                    <td key={index}>
                      {(response.bebas2d && response.bebas2d[index]) || ''}
                    </td>
                  ))}
                </tr>

                {response.bebas2d && response.bebas2d.length > 3 && (
                  <tr className='odd-row'>
                    <td></td>
                    {Array.from({ length: 4 }).map((_, index) => (
                      <td key={index + 4}>
                        {response.bebas2d[index + 4] || ''}
                      </td>
                    ))}
                  </tr>
                )}

                {response.naga && response.naga.length > 0 && (
                  <tr className='even-row'>
                    <td>Colok Naga</td>
                    {Array.from({ length: 4 }).map((_, index) => (
                      <td key={index}>
                        {(response.naga && response.naga[index]) || ''}
                      </td>
                    ))}
                  </tr>
                )}

                {response.naga && response.naga.length > 3 && (
                  <tr className='odd-row'>
                    <td></td>
                    {Array.from({ length: 4 }).map((_, index) => (
                      <td key={index + 4}>
                        {response.naga[index + 4] || ''}
                      </td>
                    ))}
                  </tr>
                )}

                {response.naga && response.naga.length > 7 && (
                  <tr className='even-row'>
                    <td></td>
                    {Array.from({ length: 4 }).map((_, index) => (
                      <td key={index + 8}>
                        {response.naga[index + 8] || ''}
                      </td>
                    ))}
                  </tr>
                )}

                {response.detail && response.detail.macau_shio_1 && response.detail.macau_shio_2 && (
                  <tr className='odd-row'>
                    <td>Macau Shio</td>
                    <td colSpan="4">{response.detail.macau_shio_1 + ' - ' + response.detail.macau_shio_2}</td>
                  </tr>
                )}

                <tr className='odd-row'>
                  <td>Shio</td>
                  <td colspan="4">{response.detail.shio_number + '_' + response.shioName}</td>
                  {/* <td colspan="4">{response.detail.shio}</td> */}
                </tr>

                <tr className='even-row'>
                  <td>Silang Homo</td>
                  <td colspan="4">{response.detail.homoBelakang}</td>
                </tr>

                <tr className='odd-row'>
                  <td>Tengah Tepi</td>
                  <td colspan="4">{response.detail.tepi}</td>
                </tr>

                <tr className='even-row'>
                  <td>Kembang Kempis Kembar</td>
                  <td colspan="4">{response.detail.kembangBelakang}</td>
                </tr>

                <tr className='odd-row'>
                  <td>Dasar</td>
                  <td colspan="4">{props.t(response.detail.dasGG) + ' - ' + props.t(response.detail.dasBS)}</td>
                </tr>
                {/* } */}
              </tbody>
            </table>
          </div>

        </div>


      </div>


    </div>
  );
};

export default withTranslation()(InfoResultLinkPopup);
